export default __webpack_public_path__ + "static/media/department_superior.7b9e4c09.png";